export default __webpack_public_path__ + "static/media/a014-long.42f4728d.svg";